//export const projectColors = ['#fdcfd5', '#f2cbf3', '#b687f4', '#d3b7f8', '#cac3f5', '#97b0ea', '#6eaff0', '#ade3ff', '#fbb2b2', '#fcc3b4', '#fbc59e', '#faec8c', '#e3efab', '#caedb3', '#a3e7e1', '#dadadf'];
export const projectColors = [
	'#BC97F5',
	'#CE93D8',
	'#F98BD2',
	'#F69695',
	'#FFCBD0',
	'#FFDF83',
	'#FDEF95',
	'#7DEAB7',
	'#80CBC3',
	'#8AC7FF',
	'#B9DCFF',
	'#E6E6ED',
];

export class ColorUtils {
	/**
	 * Returns best match black or white, so it can be displayed on either dark og light background
	 * @param {string} backgroundColor color hex value
	 */
	static getInvertedTextColor(backgroundColor) {
		let brightness = 255;
		const brightnessThreshold = 165;
		const c = parseInt(backgroundColor.slice(1), 16);
		const r = c >> 16;
		const g = (c >> 8) & 0x00ff;
		const b = c & 0x0000ff;
		brightness = 0.2126 * r + 0.7152 * g + 0.0722 * b;
		return brightness < brightnessThreshold ? '#ffffff' : '#000000';
	}

	/**
	Pink2: #
	Purple1: #
	Purple2: #
	Purple3: #cac3f5
	Bule1: #97b0ea
	Blue2: #6eaff0
	Blue3: #ade3ff
	Red1: #fbb2b2
	Red2: #fcc3b4
	Orange1: #fbc59e
	Yellow: #faec8c
	Green1: #e3efab
	Green2: #caedb3
	Green3: #a3e7e1
	Grey: #dadadf
	 */
}
